import * as Sentry from '@sentry/react';
import { redirect, useRouteLoaderData } from 'react-router-dom';
import { isLoggedIn } from '@/api/auth';
import { getUser, User } from '@/api/user';

export interface LoggedInLayoutLoaderData {
  user: User;
}

export default async function loggedInLayoutLoader() {
  if (!isLoggedIn()) {
    return redirect('/login');
  }

  const user = await getUser();

  Sentry.setUser({
    id: user.id,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
  });

  return {
    user,
  } as LoggedInLayoutLoaderData;
}

/** @public */
export function useLoggedInLayoutLoaderData() {
  return useRouteLoaderData<LoggedInLayoutLoaderData>('logged-in')!;
}
